<template>
  <div>
    <v-card
      flat
      class="d-flex flex-row justify-space-around align-center width100p px-6 pt-1 mx-0"
      style="background-color: #e2f4ff !important"
    >
      <v-btn x-small text @click="$router.push('/')" color="primary">
        <v-icon x-small color="primary">mdi-arrow-left</v-icon>
        Back to EyeDock
      </v-btn>

      <div class="overline d-flex flex-row align-center">
        <v-img
          class="mr-2"
          :src="eyescholarPath + eyescholarIcon"
          max-width="25"
          max-height="25"
        ></v-img>
        Eye Scholar - Learn and Practice Refraction &amp; Retinoscopy
      </div>

      <v-dialog v-model="dialog" max-width="600">
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="primary" text small v-bind="attrs" v-on="on">
            About Eye Scholar
          </v-btn>
        </template>
        <v-card>
          <v-card-title
            class="text-h5 orangeCardTitle d-flex flex-row align-center"
          >
            <v-img
              class="mr-4"
              :src="eyescholarIcon"
              max-width="30"
              max-height="30"
            ></v-img>
            <div>About Eye Scholar</div>
            <v-spacer></v-spacer>
            <v-btn color="primary" icon @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="pa-4 darkerCardText"
            ><page articleSlug="about-eye-scholar" :showHeader="false"></page>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-card>
    <div class="row-container relative" v-if="isStudent || isAdmin">
      <loading id="loading" class="loadingClass"></loading>
      <iframe
        :src="eyescholarPath + eyescholarIframe"
        class="second-row"
        onload="document.getElementById('loading').style.display = 'none';"
      ></iframe>
    </div>
    <div v-else class="alertDiv width100p">
      <v-alert
        border="left"
        colored-border
        type="error"
        elevation="0"
        class="mx-auto"
        style="background-color: #ffedf0"
      >
        This complimentary version of Eye Scholar is only available for EyeDock
        users who are registered as a student/faculty user.
        <user-login v-if="!isLoggedIn" class="mt-4" buttonLabel="Log In">
        </user-login>
      </v-alert>
      <!-- LI? {{ isLoggedIn }} -->
      <!-- <user-login /> -->
    </div>
  </div>
</template>

<script>
import UserMixin from "@/assets/js/UserMixin";
import Page from "@/components/pagesStuff/Page";
import Loading from "@/components/universalStuff/Loading.vue";
import UserLogin from "@/components/universalStuff/UserLogin.vue";

export default {
  name: "EyeScholar",
  props: {},
  components: {
    Page,
    Loading,
    UserLogin,
  },
  mixins: [UserMixin],
  data: function () {
    return {
      dialog: false,
      eyescholarPath: "https://www.eyedock.com/eyescholar_files/",
      eyescholarIframe: "refractionTut.php",
      eyescholarIcon: "Eyescholar_Icon.svg",
    };
  },
  methods: {},
  computed: {},
  mounted() {},
  metaInfo() {
    return {
      title: "EyeDock/Eye Scholar | Learn Refraction and Retinoscopy",
    };
  },
};
</script>

<style scoped>
.blueBkg {
  background-color: #ebeded;
}
body,
html {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}
.row-container {
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;

  /*
	background-color: rgb(177, 177, 205);
*/

  overflow: hidden;
}

.second-row {
  flex-grow: 1;
  border: none;
  margin: 0;
  padding: 0;
}
.alertDiv {
  max-width: 600px;
  margin: 100px auto;
  text-align: center;
}
.loadingClass {
  position: absolute;
  top: 6em;
  left: 40%;
  transform: translate(-50%, -50%);
}
</style>
